"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunk64FNDIZXcjs = require('./chunk-64FNDIZX.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_2/pool/CPIPoolV2_2.ts
var CPIPoolV2_2 = (_class = class extends _chunk64FNDIZXcjs.CPIPoolV2_1 {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v2_2}
}, _class.__initStatic(), _class);



exports.CPIPoolV2_2 = CPIPoolV2_2;
//# sourceMappingURL=chunk-WL32XBDW.cjs.map